"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _DropdownArrow = _interopRequireDefault(require("../Shared/DropdownArrow"));

var _DropdownContent = _interopRequireDefault(require("../Shared/DropdownContent"));

var _MenuButton = _interopRequireDefault(require("../Shared/MenuButton"));

var _MenuLine = _interopRequireDefault(require("../Shared/MenuLine"));

var _MenuProvider = require("../Shared/MenuProvider");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var StyledDropDown = (0, _styledComponents.default)(_DropdownContent.default).withConfig({
  displayName: "NavigationAbout__StyledDropDown",
  componentId: "lb66ad-0"
})(["right:16px;top:55px;border-radius:3px;width:185px;", ";"], function (props) {
  return props.isDropdownExpanded && 'display: block;';
});
var MenuButton = (0, _styledComponents.default)(_MenuButton.default).withConfig({
  displayName: "NavigationAbout__MenuButton",
  componentId: "lb66ad-1"
})(["color:", ";font-size:11px;white-space:nowrap;"], function (props) {
  return props.theme.carvana.white.primary;
});
var StyledButton = (0, _styledComponents.default)(_MenuButton.default).withConfig({
  displayName: "NavigationAbout__StyledButton",
  componentId: "lb66ad-2"
})(["font-size:12px;height:39px;justify-content:flex-start;padding:0px 18px;letter-spacing:0;"]);
var StyledArrowDropDown = (0, _styledComponents.default)(_DropdownArrow.default).withConfig({
  displayName: "NavigationAbout__StyledArrowDropDown",
  componentId: "lb66ad-3"
})(["fill:", ";width:20px;"], function (_ref) {
  var isDropdownExpanded = _ref.isDropdownExpanded,
      theme = _ref.theme;
  return isDropdownExpanded ? theme.carvana.blue.primary : theme.carvana.white.primary;
});

var MenuTitle = _styledComponents.default.span.attrs({
  "data-qa": "menu-title"
}).withConfig({
  displayName: "NavigationAbout__MenuTitle",
  componentId: "lb66ad-4"
})(["color:", ";"], function (_ref2) {
  var isDropdownExpanded = _ref2.isDropdownExpanded,
      theme = _ref2.theme;
  return isDropdownExpanded ? theme.carvana.blue.primary : theme.carvana.white.primary;
});

var MenuWrapper = _styledComponents.default.div.attrs({
  "data-qa": "menu-wrapper"
}).withConfig({
  displayName: "NavigationAbout__MenuWrapper",
  componentId: "lb66ad-5"
})(["display:inline-flex;padding:5px 20px 5px 2px;position:relative;", ";"], function (props) {
  return props.isDropdownExpanded && 'z-index: 101;';
});

var OutsideClickWrapper = _styledComponents.default.div.attrs({
  "data-qa": "outside-click-wrapper"
}).withConfig({
  displayName: "NavigationAbout__OutsideClickWrapper",
  componentId: "lb66ad-6"
})(["display:none;", ";background:none;position:fixed;top:0;left:0;right:0;bottom:0;width:100%;height:100%;z-index:99;"], function (props) {
  return props.isDropdownExpanded && 'display: block;';
});

var _ref5 = _react.default.createElement(_MenuLine.default, null);

var _ref6 = _react.default.createElement(StyledButton, {
  href: "/vehicle-protection-plans",
  target: "_self"
}, "Vehicle Protection");

var _ref7 = _react.default.createElement(_MenuLine.default, null);

var _ref8 = _react.default.createElement(StyledButton, {
  href: "/reviews",
  target: "_self"
}, "Customer Reviews");

var _ref9 = _react.default.createElement(_MenuLine.default, null);

var _ref10 = _react.default.createElement(StyledButton, {
  href: "/careers",
  target: "_self"
}, "Careers");

var NavigationAbout = function NavigationAbout(_ref3) {
  var partner = _ref3.partner;
  var isExtendedWarrantyOffered = partner.isExtendedWarrantyOffered;
  return _react.default.createElement(_MenuProvider.MenuContext.Consumer, {
    "data-qa": "navigation-about"
  }, function (_ref4) {
    var isAboutCarvanaExpanded = _ref4.isAboutCarvanaExpanded,
        setAboutCarvanaMenuState = _ref4.setAboutCarvanaMenuState,
        isInDotCom = _ref4.isInDotCom;
    return _react.default.createElement(_react.Fragment, null, _react.default.createElement(MenuWrapper, {
      isDropdownExpanded: isAboutCarvanaExpanded,
      onMouseEnter: function onMouseEnter() {
        return setAboutCarvanaMenuState(true);
      },
      onMouseLeave: function onMouseLeave() {
        return setAboutCarvanaMenuState(false);
      }
    }, _react.default.createElement(MenuButton, {
      onTouchStart: function onTouchStart() {
        return setAboutCarvanaMenuState(!isAboutCarvanaExpanded);
      },
      disableHref: true
    }, _react.default.createElement(MenuTitle, {
      isDropdownExpanded: isAboutCarvanaExpanded
    }, "About Carvana"), _react.default.createElement(StyledArrowDropDown, {
      isDropdownExpanded: isAboutCarvanaExpanded
    })), _react.default.createElement(StyledDropDown, {
      isDropdownExpanded: isAboutCarvanaExpanded
    }, _react.default.createElement(StyledButton, {
      href: "/about-us",
      target: "_self",
      isInDotCom: isInDotCom
    }, "About Us"), _ref5, isExtendedWarrantyOffered && _ref6, _ref7, _ref8, _ref9, _ref10)), _react.default.createElement(OutsideClickWrapper, {
      isDropdownExpanded: isAboutCarvanaExpanded,
      onTouchStart: function onTouchStart() {
        return setAboutCarvanaMenuState(false);
      }
    }));
  });
};

NavigationAbout.defaultProps = {
  partner: {
    isExtendedWarrantyOffered: true
  }
};
var _default = NavigationAbout;
exports.default = _default;
module.exports = exports.default;